import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiFaq } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiFaqDialogData {
  faqs?: ApiFaq[];
}

@Component({
  selector: 'app-multi-faq-dialog',
  templateUrl: './multi-faq-dialog.component.html',
  styleUrls: ['./multi-faq-dialog.component.css'],
  standalone: false,
})
export class MultiFaqDialogComponent implements OnInit {

  //FAQ×言語数
  faqs: ApiFaq[] = [];
  faqsFormGroup!: FormGroup;
  faqsArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiFaqDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiFaqDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.faqs = this.data.faqs!;
    if (!this.faqs) {
      this.faqs = [];
    }
    this.createForm();
    this.faqsArrayControl = this.faqsFormGroup.get('faqs') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.faqsFormGroup.disable();
    }
  }

  //FAQフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.faqs.length ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let faq = '';
      let trans_faq = '';
      for (const value of this.faqs) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          faq = value.faq;
          trans_faq = value.trans_faq;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          faq: [faq],
          transFaq: [trans_faq],
        }
      ));
      index++;
    }
    this.faqsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        faqs: arrayControl
      }
    );
  }

  //更新ボタン
  addFaqs(): void {
    if (this.faqsFormGroup.valid) {
      let faqs = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.faqsArrayControl.controls[index];
        faqs.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            faq: ctrl.get('faq')!.value,
            trans_faq: ctrl.get('transFaq')!.value,
          }
        )
      }
      this.faqs = faqs;
      this.dialogRef.close(this.faqs);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.faqsFormGroup.get('autoAllTrans')!.value;
    for (const faq of this.faqsArrayControl.controls) {
      faq.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.faqsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const faq of this.faqsArrayControl.controls) {
      if (!faq.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.faqsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
